<template>
    <div id="home">
        <img id="bg" class="bg" :src="bgUrl" />
        <img class="logo" src="@/assets/home/logo.png"  />
        <!-- 头像盒子 -->
        <div class="bigcj-mainbox normal-box">
            <div class="bigcj-avatarBox" >
                <div class="avatarcols" 
                    v-for="(el) in avatarList" 
                    :key="el.id"
                    :style="setStyle(el.id)"
                >
                    <div 
                        class="avatarbox avatar_shadow"  
                        v-for="item in el.children" 
                        :key="item.pkId" 
                        :style="vatarBoxHeight"
                    >
                        <img class="" v-if="!item.avatarImageUrl" :id="item.avatar ? item.avatar : item.pkId+el.id" :data-url="item.avatar || item.pkId + el.id" v-lazy="showAvatar(item.avatar || item.avatarImageUrl)" />
                        <img class="" v-else :id="item.avatar ? item.avatar : item.pkId+el.id" :src="item.avatarImageUrl" />
                    </div>
                </div>
            </div>
        </div>
        <div  class="container">
            <audio id="audioStar" class="dn" src="@/assets/audio/bg.mp3" @canplaythrough="onAudioLoaded"  :loop="true"></audio>
            <audio id="audioIng" class="dn" src="@/assets/audio/ing.mp3"></audio>
            <audio id="audioEnd" class="dn" src="@/assets/audio/succ.mp3"></audio>
        </div>
        <div class="mask">
            <div class="mask-left" :class="[{'show_mask': startDraw == 2}, {'hide_mask': startDraw == 1}]"></div>
            <div class="mask-right" :class="[{'show_mask': startDraw == 2}, {'hide_mask': startDraw == 1}]"></div>
        </div>
        <draw-box class="draw-box" v-show="![1,2].includes(startDraw)"></draw-box>
        <div class="code-box y-c" v-show="showCode">
            <vue-qr class="img" id="codeImage" :text="toUrl" :logoSrc="codeLogoSrc" :logoScale="2" :margin="5"></vue-qr>
            <div class="code-text">微信扫一扫参加活动</div>
        </div>
        <div class="sele-award" v-show="![1,2].includes(startDraw)">
            <span>{{awardLv}}</span>
            <span>{{awardName}}</span>
        </div>
        <div class="sele-box x-c" id="sele-box" v-show="[0].includes(startDraw)">
            <div class="x-f sele-item">
                <div class="item-key">选择奖项:</div>
                <el-select v-model="seleValue" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                >
                    </el-option>
                </el-select>
            </div>
            <div class="x-f sele-item">
                <div class="item-key">选择人数:</div>
                <el-input
                    class="num-people"
                    type="number"
                    controls-position="none"
                    v-model="numPeople"
                    clearable
                    @input="filterInteger"
                />
            </div>
            <div class="sele-item award-list" @click="showLotteryDialogFun">当前中奖记录</div>
        </div>
        <div class="award-star x-c"  v-show="![2].includes(startDraw)">
            <img class="" @click.stop="start" src="@/assets/home/startbtn.png" />
            <div class="" @click.stop="start">{{awardText}}</div>
        </div>
        <div class="footer">© 本活动汇友驿站提供支持</div>
        
        <div 
            class="footer-container" 
            @mouseover="showControls = true" 
            @mouseleave="showControls = false"
        >
            <div class="toolbar x-f" v-show="showControls">
                <!-- 工具栏内容 -->
                <div class="toolbar-item y-c" @click="toggleAudio">
                    <div class=""></div>
                    <div class="iconfont icon-jingyin" :class="{'icon-shengyinkai' : isPaused}"></div>
                </div>
                <div class="toolbar-item y-c pr" @click="showCodeFun">
                    <div class=""></div>
                    <div class="iconfont icon-saoyisao"></div>
                    <div class="line" v-show="!showCode"></div>
                </div>
                <div class="toolbar-item y-c" @click="toggleFullscreen">
                    <div class=""></div>
                    <div class="iconfont icon-quanping" :class="{'icon-tuichuquanping': isFullscreen}"></div>
                </div>
                <!-- <div class="" @click="editstartDraw">修改状态</div> -->
            </div>
        </div>
        <el-dialog class="dialog" :visible.sync="showLotteryDialog" :title="dialogTitle" @close="closeLotteryDialog">
            <div class="">
                <template v-if="showLotteryDialogTitle">
                    <div class="tc dialog-title">
                        <div class="title">获奖名单</div>
                        <div class="award-info"><span>{{ awardLv }}</span><span>{{ awardName }}</span></div>
                    </div>
                </template>
                <div class="1 y-c one" v-if="rows.length == 1">
                    <div class="user-item pr" v-for="item in rows" :key="item.userId">
                        <img class="user-icon" :src="item.avatarUrl ? item.avatarUrl : rowsUserIcon" />
                        <img class="user-bg" :src="rowsBgIcon" />
                        <div class="userNm">{{ item.uname || item.userName }}</div>
                    </div>
                </div>
                <div class="x-c two" v-else-if="rows.length == 2">
                    <div class="user-item pr" v-for="item in rows" :key="item.userId">
                        <img class="user-icon" :src="item.avatarUrl ? item.avatarUrl : rowsUserIcon" />
                        <img class="user-bg pa" :src="rowsBgIcon" />
                        <div class="userNm">{{ item.uname || item.userName }}</div>
                    </div>
                </div>
                <div class="3 x-f three" v-else-if="rows.length > 2">
                    <div class="user-item pr" v-for="item in rows" :key="item.userId">
                        <img class="user-icon" :src="item.avatarUrl ? item.avatarUrl : rowsUserIcon" />
                        <img class="user-bg pa" :src="rowsBgIcon" />
                        <div class="userNm">{{ item.uname || item.userName }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import drawBox  from "./components/drawBox";
import { activityUserInfList, listActivityPrizeInf, activityPrizeUserPd, activityPrizeUserPdusers, ossinf, activityInf } from "@/api/index";
import VueQr from 'vue-qr'
const viewId = 'Home';
export default {
    name: viewId,
    components: { drawBox, VueQr },
    computed: {
        awardLv() {
            let award = "";
            let sele = this.options.filter(item => item.value == this.seleValue);
            if (sele.length) {
                award = sele[0]["value"];
            }
            return award ;
        },
        awardName() {
            let award = "";
            let sele = this.options.filter(item => item.value == this.seleValue);
            if (sele.length) {
                award = sele[0]["label"];
            }
            return award ;
        },
    },
    data() {
        return {
            avatarList: [],
            isPc: null,
            scale: 1,
            numPeople: 1,
            options: [],
            seleValue: "",
            awardText: "开始抽奖",
            startDraw: 0, // 是否开始抽奖
            vatarBoxHeight: {},
            isPaused: true, // 控制是否暂停
            showControls: false, // 控制按钮显示
            isFullscreen: false, // 控制全屏状态
            showCode: false, // 控制二维码显示
            showLotteryDialog: false, // 控制抽奖记录弹窗显示
            dialogTitle: "", // 抽奖记录弹窗标题
            rows: [], // 中奖记录数据
            rowsBgIcon: require("@/assets/home/userbg.png"), // 中奖记录背景图
            rowsUserIcon: require("@/assets/home/home.png"),    // 中奖记录头像图
            showLotteryDialogTitle: false, // 控制抽奖记录弹窗标题
            routerItem: {},
            toUrl: "", // 二维码地址
            codeLogoSrc: require("@/assets/home/codeLogoSrc.png"), // 二维码logo图标
            queryInterval: null,
            keydownTimer: null, // 防抖定时器
            bgUrl: require("@/assets/home/bg.png"), // 背景图 URL
        }
    },
    created() {
        this.isPc = window.screen.availWidth >= 850 ? true : false;
        // 获取url参数信息
        let search = window.location.search;
        let searchParams = {};
        if (search) {
            let searchList = search.replace("?", "").split("&");
            searchList.forEach(param => {
                let [key, value] = param.split("=");
                searchParams[key] = decodeURIComponent(value);
            });
        }
        this.routerItem = searchParams ? searchParams : false;
        if (this.routerItem && this.routerItem.activityId) {
            this.toUrl = `https://mp.huiyouyizhan.cn/?activityId=${this.routerItem.activityId}`;
            this.activityUserInfList();
            this.listActivityPrizeInf();   // 获取奖品列表
            this.startQueryActivityUserInfList(); // 启动定时查询
            // 获取场次信息;
            this.activityInf();
        }
    },
    mounted() {
        this.setVatarBoxHeight();
        // 添加按下键盘事件监听
        window.addEventListener('keydown', this.handleKeyDown);
    },
    methods: {
        handleKeyDown(event) {
            if (this.keydownTimer) {
                clearTimeout(this.keydownTimer); // 清除之前的定时器
            }
            this.keydownTimer = setTimeout(() => {
            if (["g", "G"].includes(event.key)) {
                // 按 G 键开始抽奖
                this.start(); 
            } else if (["n", "N"].includes(event.key)) {
                // 按 N 键停止抽奖
                this.drawIng();
                this.stopFlipAnimation(); 
            } else if (["f", "F"].includes(event.key)) {
                this.toggleFullscreen(); // 按 F 键切换全屏
            } else if (["d", "D"].includes(event.key)) {
                this.showLotteryDialogFun(); // 按 D 键显示当前中奖记录
            }
        }, 300); // 设置防抖延时为 300 毫秒
        },
        // 定时查询 activityUserInfList 接口
        startQueryActivityUserInfList() {
            // 每 5 秒调用一次 activityUserInfList 接口
            this.queryInterval = setInterval(() => {
                this.activityUserInfList();
            }, 5000);
        },
        // 启动翻转动画
        startFlipAnimation() {
            // 取父类
            const avatarCols = document.querySelectorAll('.avatarcols');
            const avatarColsLength = avatarCols.length; // 获取父类的长度
            const avatarColsMid = parseInt(avatarColsLength / 2); // 中间值
            // 前半部分
            for (let i = 0; i < avatarColsMid; i++) {
                const avatarCol = avatarCols[i];
                let Index = i + 1; // 计算索引值
                const avatarBoxs = avatarCol.querySelectorAll('.avatarbox'); // 获取子类
                const avatarBoxsLength = avatarBoxs.length; // 获取子类的长度
                setTimeout(() => {
                    for (let j = 0; j < avatarBoxsLength; j++) {
                        const avatarBox = avatarBoxs[j];
                        setTimeout(() => {
                            avatarBox.classList.add('flip-up-down'); // 添加翻转动画类
                        }, j * 80); // 每个元素延迟 50ms
                    }
                }, Index * 200); // 每个父类延迟 200ms
            }
            // 后半部分
            for (let i = avatarColsLength; i > avatarColsMid; i--) {
                const avatarCol = avatarCols[i-1];
                let Index = (avatarColsLength+1) - i; // 计算索引值
                const avatarBoxs = avatarCol.querySelectorAll('.avatarbox'); // 获取子类
                const avatarBoxsLength = avatarBoxs.length; // 获取子类的长度
                setTimeout(() => {
                    for (let j = 0; j < avatarBoxsLength; j++) {
                        const avatarBox = avatarBoxs[j];
                        setTimeout(() => {
                            avatarBox.classList.add('flip-up-down'); // 添加翻转动画类
                        }, j * 80); // 每个元素延迟 80ms
                    }
                }, Index * 200); // 每个父类延迟 200ms
            }
        },  
        // 停止翻转动画
        stopFlipAnimation() {
            // 移除所有元素上的 flip-up-down 类
            const avatarCols = document.querySelectorAll('.avatarbox');
            avatarCols.forEach((col) => {
                col.classList.remove('flip-up-down');
            });
        },
        editstartDraw() {
            this.startDraw = !this.startDraw;
        },
        // 停止定时查询
        stopQueryActivityUserInfList() {
            if (this.queryInterval) {
                clearInterval(this.queryInterval);
                this.queryInterval = null;
            }
        },
        onAudioLoaded() {
            // console.info("音频加载完成");
        },
        // 头像盒子高度
        setVatarBoxHeight() {
            let h = document.getElementsByClassName("sele-box"); // 获取屏幕高度,
            if (h) {
                h = h[0].offsetTop; // 获取屏幕高度,
                h = (h - 70 - 20 - 30) / 10;
                this.vatarBoxHeight = {height: h + "px"};
            }
        },
        setStyle(id) {
            const len = this.avatarList.length; // 数组总长度
            const half = parseInt(len / 2) < 1 ? 1 : parseInt(len / 2); // 数组中间值
            let Index = 1;
            let style = { transform: "" };
            let max = "0.990984"; // 最大值
            let min = "0.700234"; // 最小值
            let numHalf = Number(max) - Number(min); // 总差值
            let self = numHalf / len; // 每步的步长值;
            if (id == 1 || len == id) {
                Index = max;
            } else if (id < half) {
                Index = Number(max) - self * id;
            } else if (id == half || id == half + 1) {
                Index = Number(max) - self * id;
            } else if (id > half) {
                Index = Number(min) + self * id
            }
            style.transform = `scale(${Index}, ${Index})`;
            return style;
        },  
        playAudioStar() {
            let audioStar = document.getElementById("audioStar");
            try {
                audioStar.play();
                this.isPaused = false; // 播放时设置为未暂停
            } catch (e) {
                console.error("音频播放失败", e);
            }
        },
        start() {
            if (!this.numPeople) {
                this.$message.error("请输入抽奖人数");
                return;
            }
            if (this.queryInterval) {
                // 停止定时查询
                this.stopQueryActivityUserInfList();
            }
            // 正在向后台发送请求再次被点击跳出;
            if (this.awardText == "正在充能...") return;
            if (this.startDraw == 1) {
                this.drawIng();
                this.stopFlipAnimation(); // 停止翻转动画
                return;
            }
            if (this.rows.length) {
                this.rows = [];
                this.awardText = "停止抽奖";
                this.startDraw = 1;
                let audioStar = document.getElementById("audioStar");
                audioStar.pause();
                let audioIng = document.getElementById("audioIng");
                audioIng.play();
                this.activityPrizeUserPd();
                this.showCode = false;
                return;
            }
            // 如果当前中奖列表中存在中奖人，则不允许再次抽奖
            let audioStar = document.getElementById("audioStar");
            audioStar.pause();
            let audioIng = document.getElementById("audioIng");
            audioIng.play();
            this.activityPrizeUserPd();
            this.showCode = false;
        }, 
        drawIng () {
            let audioIng = document.getElementById("audioIng");
            audioIng.play();
            this.startDraw = 2;
            this.drawEnd();
            this.awardText = "开始抽奖";
        },
        drawEnd () {
            audioIng.pause();
            let audioEnd = document.getElementById("audioEnd");
            audioEnd.play();
            this.showLotteryDialog = true;
            this.showLotteryDialogTitle = true;
            this.dialogTitle = "";
            // this.dialogTitle = `${this.awardLv}(${this.numPeople}人)`;
        },
        showLotteryDialogFun() {
            // this.showLotteryDialog = true;
            // 查询当前奖品的中奖信息;
            this.activityPrizeUserPdusers("dialogFun");
            this.showLotteryDialogTitle = false;
            this.dialogTitle = `${this.awardLv}(${this.rows.length}人)`;
        },
        toggleAudio() {
            let audioStar = document.getElementById("audioStar");
            if (this.isPaused) {
                audioStar.play();
            } else {
                audioStar.pause();
            }
            this.isPaused = !this.isPaused;
        },
        toggleFullscreen() {
            const elem = document.documentElement;
            this.isFullscreen = !this.isFullscreen;
            if (!document.fullscreenElement) {
                elem.requestFullscreen().catch(err => {
                    console.error(`全屏失败: ${err.message}`);
                });
            } else {
                document.exitFullscreen().catch(err => {
                    console.error(`退出全屏失败: ${err.message}`);
                });
            }
        },
        showCodeFun() {
            this.showCode = !this.showCode;
        },
        closeLotteryDialog() {
            this.showLotteryDialog = false;
            this.startDraw = 0;
            this.awardText = "开始抽奖";
        },
        // 获取参与活动的用户信息列表
        activityUserInfList() {
            activityUserInfList({
                activityId: this.routerItem.activityId,
                signin: "Y"
            })
            .then(res => {
                let list = res.rows;
                if (list && list.length) {
                    // 头像列表最大返回200个，超出或等于200个则停止查询；
                    if (list.length >= 200) {
                        if (this.queryInterval) {
                            this.stopQueryActivityUserInfList(); // 停止定时查询
                        }
                        // return;
                    }
                    let avatarList = []; // 当前已有的用户ID;
                    if (this.avatarList.length) {
                        for (let i = 0; i < this.avatarList.length; i++) {
                            let item = this.avatarList[i];
                            if (item.children && item.children.length) {
                                for (let j = 0; j < item.children.length; j++) {
                                    let user = item.children[j];
                                    if (user.userId && !avatarList.includes(user.userId)) {
                                        avatarList.push(user.userId); // 头像列表;
                                    }
                                }
                            }
                        }
                    }
                    if (avatarList.length == list.length) {
                        this.isImageUrl();
                        return;
                    };
                    this.avatarList = [];
                    // 取整;
                    let len = parseInt(list.length / 10) >= 1 ? parseInt(list.length / 10) + 1 : 1;
                    for (let i = 0; i < len; i++) {
                        let item = {};
                        if (this.avatarList.length && i < this.avatarList.length) {
                            item = this.avatarList[i];
                        } else {
                            item = { id: i+1, children: [] };
                        }
                        if (len > 1) {
                            if (!item.children || !item.children.length) {
                                item.children = [];
                            }
                            for (let j = 0; j < list.length; j++) {
                                let user = list[j];
                                if (i) {
                                    const index = (i * 10) + j;
                                    user = list[index];
                                    if (!user || !user.userId) {
                                        continue; // 如果用户信息不完整，则跳过
                                    }
                                }
                                if (item.children.length) {
                                    item.children = item.children.filter(e => e.userId); // 过滤出实际的用户，非填充用户
                                }
                                if (item.children.length < 10 && user) {
                                    item.children = item.children.filter(e => e.userId);
                                    item.children.push(user);
                                }
                            }
                            if (item.children.length < 10) {
                                for (let j = item.children.length; j < 10; j++) {
                                    let el = { pkId: j+1 };
                                    const randomId = this.avatarImageRandom();
                                    el.avatarImageUrl = `https://mp.huiyouyizhan.cn/pcImages/avatarImage/${randomId}.jpg`;
                                    item.children.push(el)
                                }
                            }
                        } else {
                            if (!item.children || !item.children.length) {
                                item.children = [];
                            }
                            for (let j = 0; j < list.length; j++) {
                                let user = list[j];
                                item.children.push(user);
                            }
                            if (item.children.length < 10) {
                                for (let j = item.children.length; j < 10; j++) {
                                    let el = { pkId: j+1 };
                                    item.children.push(el)
                                }
                            }
                        }
                        // 最多显示200位的头像；
                        if (this.avatarList.length < 20) {
                            this.avatarList.push(item);
                        }
                    }
                    // 少于200位的头像补充完整；
                    if (this.avatarList.length < 20) {
                        for (let i = this.avatarList.length; i < 20; i++) {
                            let item = { id: i+1, children: [] }
                            for (let j = 0; j < 10; j++) {
                                let child = {pkId: j+1,}
                                // 为补充的空头像也加上随机头像
                                const randomId = this.avatarImageRandom();
                                child.avatarImageUrl = `https://mp.huiyouyizhan.cn/pcImages/avatarImage/${randomId}.jpg`;
                                item.children.push(child);
                            }
                            this.avatarList.push(item);
                        }
                    }
                }
                // 如果没有数据，则补充完整；
                if (!list.length) {
                    if (this.avatarList.length < 20) {
                        for (let i = this.avatarList.length; i < 20; i++) {
                            let item = { id: i+1, children: [] }
                            for (let j = 0; j < 10; j++) {
                                let child = {pkId: j+1,}
                                const randomId = this.avatarImageRandom();
                                child.avatarImageUrl = `https://mp.huiyouyizhan.cn/pcImages/avatarImage/${randomId}.jpg`;
                                item.children.push(child);
                            }
                            this.avatarList.push(item);
                        }
                    }
                }
            })
            .catch(err => {
                console.log("异常抛出", err);
                this.stopQueryActivityUserInfList(); // 停止定时查询
            })
        },
        avatarImageRandom() {
            const randomId = Math.floor(Math.random() * 400) + 1;
            return randomId
        },
        // 获取奖品列表
        listActivityPrizeInf() {
            listActivityPrizeInf({
                activityId: this.routerItem.activityId,
            })
            .then(res => {
                this.options = res.rows;
                for (let i = 0; i < this.options.length; i++) {
                    let item = this.options[i];
                    item.value = item.plevelName;
                    item.label = item.prizeName;
                }
                this.seleValue = this.options[0]["value"];
                this.activityPrizeUserPdusers();
            })
            .catch(err => {
                console.error("获取中奖记录失败", err);
            })
        },
        // 抽奖
        activityPrizeUserPd() {
            activityPrizeUserPd({
                activityId: this.routerItem.activityId,
                level: this.options.filter(item => item.value == this.seleValue)[0]["prizeLvl"],
                number: this.numPeople,
            })
            .then(res => {
                if (res.code == "200") {
                    this.awardText = "正在充能...";
                    this.startDraw = 1;
                    let data = res.data || [];
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        item.avatarUrl = false;
                        if (item.avatar) {
                            this.ossinf(item.avatar);
                        }
                    }
                    this.rows = data;
                    
                    this.startFlipAnimation(); // 启动翻转动画
                    setTimeout(() => {
                        this.awardText = "停止抽奖";
                    }, 1000)
                } else {
                    this.startDraw = 0; // 停止抽奖
                    this.stopFlipAnimation(); // 停止翻转动画
                    let audioStar = document.getElementById("audioStar");
                    audioStar.play();
                    let audioIng = document.getElementById("audioIng");
                    audioIng.pause();
                    this.awardText = "开始抽奖";
                }
                console.log("抽奖成功", res);
            })
            .catch(err => {
                console.log("抽奖失败", err);
                this.awardText = "开始抽奖";
                this.stopFlipAnimation(); // 停止翻转动画
                if (err.msg) {
                    this.$message.error(err.msg);
                }
                this.startDraw = 0; // 停止抽奖
                let audioStar = document.getElementById("audioStar");
                audioStar.play();
                let audioIng = document.getElementById("audioIng");
                audioIng.pause();
            })
        },
        filterInteger(value) {
            // 将输入值转换为整数
            this.numPeople = parseInt(value) || 0; // 如果输入为空或无效，默认为 0
        },
        activityPrizeUserPdusers(type) {
            activityPrizeUserPdusers({
                activityId: this.routerItem.activityId,
                level: this.options.filter(item => item.value == this.seleValue)[0]["prizeLvl"],
            })
            .then(res => {
                let data = res.data || [];
                if (type == "pd") {
                    this.awardText = "停止抽奖";
                } else if (type == "dialogFun") {
                    if (!data || !data.length) {
                        this.$message.error("当前没有中奖人,请先抽奖！");
                        return;
                    }
                    this.dialogTitle = `${this.awardLv}(${data.length}人)`;
                    this.showLotteryDialog = true;
                }
                this.rows = data;
                if (this.rows && this.rows.length) {
                    for (let i = 0; i < this.rows.length; i++) {
                        let item = this.rows[i];
                        item.avatarUrl = false;
                        if (item.avatar && item.avatar.indexOf("http") == -1) {
                            this.ossinf(item.avatar);
                        }
                    }
                }
            })
            .catch(err => {
                console.log("获取中奖记录失败", err);
            })
        },
        ossinf(ossid) {
            ossinf(ossid)
            .then(res => {
                if (res.data && res.data.url) {
                    let data = JSON.parse(JSON.stringify(this.rows));
                    for(let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (item.avatar == ossid) {
                            let avatarUrl = res.data.url.replace("http://1.12.248.176:9000/ruoyi-flex", "https://mp.huiyouyizhan.cn/fileDownload");
                            item.avatarUrl = avatarUrl;
                        }
                    }
                    this.rows = data;
                    console.log("rows", this.rows);
                }
            })
        },
        showAvatar(ossid) {
            if (!ossid) return;
            if (ossid.indexOf("http") != -1) return;
            if (ossid.indexOf("https") != -1)  {
                let dom = document.getElementById(ossid);
                dom.src = ossid;
                return
            };
            this.getAvatar(ossid);
        },
        async getAvatar(ossid) {
            ossinf(ossid)
            .then(res => {
                let dom = document.getElementById(ossid);
                if (!dom) return;
                if (res.data && res.data.url) {
                    dom.src = res.data.url.replace("http://1.12.248.176:9000/ruoyi-flex", "https://mp.huiyouyizhan.cn/fileDownload");
                } else {
                    dom.src = this.rowsUserIcon;
                }
            }).catch(err => {
                console.log("异常抛出", err);
            })
        },
        isImageUrl() {
            let eventAll = document.querySelectorAll("[data-url]");
            let reqEvent = [];
            if (eventAll.length) {
                for (let i = 0; i < eventAll.length; i++) {
                    let event = eventAll[i];
                    let src = event["src"];
                    let lazy = event.getAttribute("lazy");
                    let id = event["id"];
                    if (src && src.indexOf("https") == -1 && lazy === "error" && id.length > 10) {
                        reqEvent.push(id);
                    }
                }
                console.log("异常的图片", reqEvent);
                if (!reqEvent.length) return;
                for (let i = 0; i < reqEvent.length; i++) {
                    let event = reqEvent[i];
                    this.getAvatar(event);
                }
            }
        },
        activityInf() {
            activityInf(this.routerItem.activityId)
            .then(res => {
                let rows = res.data || {};
                let { pdBgImg } = rows;
                if (pdBgImg && pdBgImg) {
                    ossinf(pdBgImg)
                    .then(res => {
                        if (res.data && res.data.url) {
                            this.bgUrl = res.data.url.replace("http://1.12.248.176:9000/ruoyi-flex", "https://mp.huiyouyizhan.cn/fileDownload");
                        } else {
                            this.bgUrl = require("@/assets/home/bg.png");
                        }
                    }).catch(err => {
                        console.log("异常抛出", err);
                    })
                }
            })
            .catch(err => {
                console.error("获取活动信息失败", err);
            })
        }
    },
    beforeDestroy() {
        // 清除定时器
        this.stopQueryActivityUserInfList();
        // 移除事件监听
        window.removeEventListener('keydown', this.handleKeyDown);
    },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 850px) {
    .pr { position: relative; }
    .pa { position: absolute; }
    .tc { text-align: center; }
    .bg {
        width: 100%; height: 100%; position: absolute;
        top: 0; left: 0; z-index: -1;
    }
    .logo { width: 280px; height: 70px; margin: 10px 0 0 30px; position: relative; z-index: 2; }
    .bigcj-mainbox { top: 50px; bottom: 0; overflow: hidden; background: transparent; border: none; }
    .normal-box { position: relative; width: 100%; height: 620px; padding: 20px 0 30px; }
    .bigcj-avatarBox { width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
        .avatarcols {
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            will-change: transform;
            padding: 0 5px;
            .avatarbox {
                img { width: 100%; height: 100%; }
            }
        }
    }
    .code-box {
        position: absolute;
        top: 32%;
        left: 58%;
        color: #fff;
        font-size: 18px;
        z-index: 9;
        .img { width: 150px; height: 150px; }
        .code-text { padding-top: 10px; }
    }
    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        .mask-left, .mask-right { width: 50%; height: 100%; position: absolute; top: 0px; background: rgba(0, 0, 0, 0.7); }
        .mask-left { left: 0; }
        .mask-right { right: 0; }
    }
    .sele-award {
        position: absolute;
        width: 100vw;
        color: #fbdcad;
        z-index: 2;
        text-align: center;
        top: 30%;
        font-size: 30px;
        font-weight: 550;
        span + span { padding-left: 5px; }
    }
    .sele-box {
        position: absolute;
        width: 100vw;
        color: #fbdcad;
        z-index: 2;
        bottom: 160px;
        // bottom: 20px;
        .sele-item + .sele-item { margin-left: 20px; }
        .item-key { min-width: 90px; }
        .num-people {
            width: 150px;
            ::v-deep .el-input__inner {
                background: #292420;
                border: 1px solid #c4a071;
                color: #fff;
            }
            /* 隐藏 type=number 的上下箭头 */
            ::v-deep input::-webkit-outer-spin-button,
            ::v-deep input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
            }
        }
        .el-select {
            width: 150px;
            ::v-deep .el-input__inner {
                background: #292420;
                border: 1px solid #c4a071;
                color: #fff;
            }
        }
        .award-list { margin-left: 20px; cursor: pointer; }
    }
    .award-star {
        position: absolute;
        bottom: 80px;
        width: 100vw;
        height: 63px;
        line-height: 63px;
        img { width: 280px; height: 63px; cursor: pointer; position: absolute; z-index: 1; }
        div { color: #634713; font-size: 30px; font-weight: 700; z-index: 2; cursor: pointer; }
    }
    .footer { position: absolute; width: 100vw; text-align: center; bottom: 0; z-index: 2; color: #fff; }
    .footer-container {
        position: absolute;
        right: 20px;
        bottom: 20px;
        width: 25px;
        height: 25px;
        background: #fff;
        border-radius: 50%;
        .toolbar {
            position: absolute;
            top: 0;
            right: 0;
            background: #292420;
            color: #fff;
            padding: 10px;
            border-radius: 10px;
            height: 50px;
            z-index: 2;
            .toolbar-item { 
                width: 80px; text-align: center; cursor: pointer; 
                .iconfont {
                    &::before {
                        font-size: 28px;
                    }
                }
                .line {
                    width: 60%;
                    height: 2px;
                    background: #fff;
                    position: absolute;
                    top: 50%;
                    transform: rotate(135deg);
                }
            }
            
        }
        &::before,
        &::after {
            content: '';
            position: absolute;
            background: #4663ff;
            transform: translate(-50%, -50%);
        }
        &::before {
            width: 15px;
            height: 3px;
            top: 50%;
            left: 50%;
        }
        &::after {
            width: 3px;
            height: 15px;
            top: 50%;
            left: 50%;
        }
    }
}
.dialog {
    .dialog-title {
        padding-bottom: 20px;
        font-size: 20px;
        .title {
            color: #f3c30d;
            font-weight: bold;
        }
        .award-info {
            padding-top: 10px;
            font-size: 16px;
            span + span { padding-left: 10px; }
        }
    }
    .user-icon {
        width: 180px;
        height: 180px;
        position: relative;
        border-radius: 50%;
        margin-top: 10px;
    }
    .user-bg {
        width: 194px;
        position: absolute;
        animation: one-to-360 1s linear infinite;
    }
    .userNm {
        padding-top: 20px;
        font-size: 20px;
        font-weight: bold;
        color: #f3c30d;
    }
    
    .one, .two, .three {
        text-align: center;
        .user-item { margin-right: 30px; }
        .user-icon { width: 150px; height: 150px; margin-left: 9px; }
        .user-bg { width: 164px; left: 0;}
    }
    .three {
        flex-wrap: wrap;
        .user-item { margin-top: 10px; }
        .user-icon { width: 120px; height: 120px; margin-left: 5px; margin-top: 3px; }
        .user-bg { width: 130px; }
    }
}
.avatar_shadow {
    animation: avatar_shadow 0.5s ease-in-out 0s alternate infinite;
}
.hide_mask {
    animation: hide_mask 1s forwards 1;
}
.show_mask {
    animation: show_mask 1s forwards 1;
}
@keyframes avatar_shadow {
	from{
		transform:scale(1);
		-webkit-transform: scale(1);
	}
	to{
		transform:scale(.8);
		-webkit-transform: scale(.8);
	}
}
@keyframes hide_mask {
	from{
		width: 50%;
	}
	to{
		width: 0%;
	}
}
@keyframes show_mask {
    from{
        width: 0%;
    }
    to{
        width: 50%;
    }
}
@keyframes flip-up-down {
    0% {
        transform: rotateX(0deg);
    }
    50% {
        transform: rotateX(90deg);
    }
    100% {
        transform: rotateX(0deg);
    }
}
@keyframes one-to-360 {
    0% {
        transform: rotate(360deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

.flip-up-down {
    animation: flip-up-down 0.2s ease-in-out 0s alternate infinite;
}
@media screen and (max-width: 850px) {

}
</style>